import React from 'react';
interface ExchangeOrderHeaderProps {
  company: {
    name: string;
    address: string[];
    phone: string;
    fax?: string;
    email: string;
    uen: string;
  };
  exchangeOrder: {
    number: string;
    supplierNo: string;
    date: string;
    soRef: string;
    staff: string;
    isDuplicate?: boolean;
  };
  supplier: {
    name: string;
    address: string[];
    attn?: string;
    tel?: string;
    fax?: string;
  };
}
export function ExchangeOrderHeader({
  company,
  exchangeOrder,
  supplier
}: ExchangeOrderHeaderProps) {
  return <>
      {/* Top Row: Logo Left, Address Right */}
      <div className="flex justify-between items-start mb-4" data-id="element-326">
        {/* Left: Logo */}
        <div data-id="element-327">
          <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center shadow-md" data-id="element-328">
            <span className="text-white font-bold text-lg" data-id="element-329">MT</span>
          </div>
        </div>

        {/* Right: Company Address - Compact */}
        <div className="text-right" data-id="element-330">
          <h1 className="text-sm text-neutral-900 mb-1" data-id="element-331">{company.name}</h1>
          <div className="text-[10px] text-neutral-500 space-y-0.5 leading-relaxed" data-id="element-332">
            {company.address.map((line, i) => <p key={i} data-id="element-333">{line}</p>)}
            <p className="mt-1" data-id="element-334">
              Tel: {company.phone} | Email: {company.email}
            </p>
            <p data-id="element-335">UEN: {company.uen}</p>
          </div>
        </div>
      </div>

      {/* EXCHANGE ORDER Title - Centered Above Box */}
      <div className="flex items-center justify-center mb-2 relative" data-id="element-336">
        <h2 className="text-lg font-bold text-neutral-900 tracking-tight text-center" data-id="element-337">
          EXCHANGE ORDER
        </h2>
        {exchangeOrder.isDuplicate && <span className="absolute right-0 text-xs font-semibold text-red-600 border border-red-300 bg-red-50 px-2 py-1 rounded" data-id="element-338">
            DUPLICATE
          </span>}
      </div>

      {/* Exchange Order Details Box */}
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-3 mb-4" data-id="element-339">
        {/* Two Column Grid */}
        <div className="grid grid-cols-2 gap-x-8 gap-y-1.5" data-id="element-340">
          {/* Left Column */}
          <div className="space-y-1.5" data-id="element-341">
            <div className="flex justify-between" data-id="element-342">
              <span className="text-xs font-medium text-neutral-600" data-id="element-343">
                EO No.:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-344">
                {exchangeOrder.number}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-345">
              <span className="text-xs font-medium text-neutral-600" data-id="element-346">
                Date:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-347">
                {exchangeOrder.date}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-348">
              <span className="text-xs font-medium text-neutral-600" data-id="element-349">
                SO Ref:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-350">
                {exchangeOrder.soRef}
              </span>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-1.5" data-id="element-351">
            <div className="flex justify-between" data-id="element-352">
              <span className="text-xs font-medium text-neutral-600" data-id="element-353">
                Supplier No.:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-354">
                {exchangeOrder.supplierNo}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-355">
              <span className="text-xs font-medium text-neutral-600" data-id="element-356">
                Staff:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-357">
                {exchangeOrder.staff}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Supplier Block */}
      <div className="mb-6 bg-neutral-50 border border-neutral-200 rounded-lg p-4" data-id="element-358">
        <p className="text-sm font-bold text-neutral-900 mb-2 uppercase tracking-wide" data-id="element-359">
          TO:
        </p>
        <div className="space-y-1" data-id="element-360">
          <p className="text-base font-semibold text-neutral-900" data-id="element-361">
            {supplier.name}
          </p>
          <div className="text-sm text-neutral-700 space-y-0.5" data-id="element-362">
            {supplier.address.map((line, i) => <p key={i} data-id="element-363">{line}</p>)}
          </div>
          {(supplier.attn || supplier.tel || supplier.fax) && <div className="text-sm text-neutral-700 space-y-0.5 mt-2" data-id="element-364">
              {supplier.attn && <p data-id="element-365">Attn: {supplier.attn}</p>}
              {supplier.tel && <p data-id="element-366">Tel: {supplier.tel}</p>}
              {supplier.fax && <p data-id="element-367">Fax: {supplier.fax}</p>}
            </div>}
        </div>
        <div className="border-t border-neutral-200 pt-3 mt-3" data-id="element-368">
          <p className="text-xs text-neutral-700 italic" data-id="element-369">
            In exchange for this order, please issue:
          </p>
        </div>
      </div>
    </>;
}